// Hero Slideshow Script - Speichern als: assets/hero-slideshow.js

// Warten bis DOM geladen ist
document.addEventListener('DOMContentLoaded', initHeroSlideshows);

// Auch bei Shopify Section Loads (Theme Editor)
document.addEventListener('shopify:section:load', function(event) {
  const slideshow = event.target.querySelector('.hero-slideshow-container');
  if (slideshow && !slideshow.dataset.initialized) {
    new HeroSlideshow(slideshow);
  }
});

function initHeroSlideshows() {
  const slideshows = document.querySelectorAll('.hero-slideshow-container');
  console.log('Found slideshows:', slideshows.length);
  
  slideshows.forEach(container => {
    if (!container.dataset.initialized) {
      new HeroSlideshow(container);
    }
  });
}

class HeroSlideshow {
  constructor(container) {
    console.log('Initializing slideshow for:', container);
    
    this.container = container;
    this.container.dataset.initialized = 'true';
    
    this.slides = container.querySelectorAll('.hero-slide');
    this.dots = container.querySelectorAll('.slideshow-dot');
    this.prevBtn = container.querySelector('.slideshow-prev');
    this.nextBtn = container.querySelector('.slideshow-next');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoplayInterval = null;
    this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
    this.isHovered = false;
    
    console.log('Slideshow config:', {
      totalSlides: this.totalSlides,
      autoplaySpeed: this.autoplaySpeed,
      hasDots: this.dots.length > 0,
      hasArrows: !!this.prevBtn && !!this.nextBtn,
      slides: this.slides
    });
    
    this.init();
  }
  
  init() {
    // Return early if only one slide
    if (this.totalSlides <= 1) {
      console.log('Only one slide, skipping slideshow functionality');
      return;
    }
    
    this.setupEventListeners();
    this.startAutoplay();
    console.log('Slideshow initialized successfully');
  }
  
  setupEventListeners() {
    // Dot navigation
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        console.log('Dot clicked:', index);
        this.goToSlide(index);
      });
    });
    
    // Arrow navigation
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        console.log('Next button clicked');
        this.nextSlide();
      });
    }
    
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        console.log('Prev button clicked');
        this.prevSlide();
      });
    }
    
    // Hover events for autoplay
    this.container.addEventListener('mouseenter', () => {
      this.isHovered = true;
      console.log('Mouse entered slideshow');
    });
    
    this.container.addEventListener('mouseleave', () => {
      this.isHovered = false;
      console.log('Mouse left slideshow');
    });
    
    // Keyboard navigation (global)
    document.addEventListener('keydown', (e) => {
      if (this.isInViewport()) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.prevSlide();
        }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.nextSlide();
        }
      }
    });
    
    // Touch/Swipe support for mobile
    this.setupTouchEvents();
  }
  
  setupTouchEvents() {
    let startX = 0;
    let endX = 0;
    
    this.container.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    this.container.addEventListener('touchend', (e) => {
      endX = e.changedTouches[0].clientX;
      this.handleSwipe(startX, endX);
    }, { passive: true });
  }
  
  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.prevSlide();
      }
    }
  }
  
  isInViewport() {
    const rect = this.container.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }
  
  goToSlide(index) {
    console.log('Going to slide:', index, 'from:', this.currentSlide);
    
    // Remove active class from all slides and dots
    this.slides.forEach((slide, i) => {
      if (i === index) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
    
    this.dots.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
    
    this.currentSlide = index;
  }
  
  nextSlide() {
    const next = (this.currentSlide + 1) % this.totalSlides;
    this.goToSlide(next);
  }
  
  prevSlide() {
    const prev = (this.currentSlide - 1 + this.totalSlides) % this.totalSlides;
    this.goToSlide(prev);
  }
  
  startAutoplay() {
    if (this.autoplaySpeed > 0 && this.totalSlides > 1) {
      console.log('Starting autoplay with speed:', this.autoplaySpeed);
      
      this.autoplayInterval = setInterval(() => {
        if (!this.isHovered && this.isInViewport()) {
          this.nextSlide();
        }
      }, this.autoplaySpeed);
    }
  }
  
  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
      console.log('Autoplay stopped');
    }
  }
  
  destroy() {
    this.stopAutoplay();
    this.container.dataset.initialized = 'false';
  }
}